import { render } from "./ConfigEditorWrapper.vue?vue&type=template&id=0d12ce30&scoped=true"
import script from "./ConfigEditorWrapper.vue?vue&type=script&lang=js"
export * from "./ConfigEditorWrapper.vue?vue&type=script&lang=js"

import "./ConfigEditorWrapper.vue?vue&type=style&index=0&id=0d12ce30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d12ce30"]])

export default __exports__